import React, { useMemo } from 'react';
import { useTranslation } from '@wix/yoshi-flow-editor';

import { useGetLayoutSize } from '../../../../components-shared/LayoutSizeProvider';
import { sortByDispatchType } from '../../../../components-shared/FulfillmentPicker/dispatchType';
import type { FulfillmentPickerProps } from '../../../../components-shared/FulfillmentPicker';
import { fulfillmentPickerDataHooks } from '../../../../components-shared/FulfillmentPicker/constants';

import { classes, st } from './ButtonGroupFulfillmentPicker.st.css';

export const ButtonGroupFulfillmentPicker: React.FC<FulfillmentPickerProps> = ({
  options,
  selectedType,
  isHidden,
  onSelect,
  className,
}) => {
  const { t } = useTranslation();
  const { layoutSize } = useGetLayoutSize();
  const sortedOptions = useMemo(() => sortByDispatchType(options), [options]);

  if (isHidden || sortedOptions.length === 0) {
    return null;
  }

  return (
    <div
      role="group"
      aria-label={t('header_olo.fulfillmentPicker.ariaLabel')}
      className={st(classes.root, { [layoutSize]: true }, className)}
      data-hook={fulfillmentPickerDataHooks.root()}
    >
      {sortedOptions.map(({ type, label, disabled }, index) => (
        <button
          key={type}
          type="button"
          disabled={disabled}
          tabIndex={disabled ? -1 : 0}
          aria-pressed={selectedType === type}
          aria-label={t('header_olo.fulfillmentPicker.button.ariaLabel', {
            label,
            index: index + 1,
            total: sortedOptions.length,
          })}
          className={st(classes.button, {
            selected: selectedType === type,
            disabled,
          })}
          onClick={() => type !== selectedType && onSelect(type)}
          data-hook={fulfillmentPickerDataHooks.option({ type })}
        >
          {label}
        </button>
      ))}
    </div>
  );
};
